import React from "react";
import { useWatchState, setState } from "@/store";
import { Modal, Button, Tag } from "antd";
import "./style.less";

const { CheckableTag } = Tag;

const MODAL_STATE_PATH = "modal.scopeSelect";

const App = () => {

    const [[SCOPE = []]] = useWatchState(["$_SCOPE"])
    const [[{ title = "选择领域", show, hide, width = 800, selectScope = [], callback }]] = useWatchState([MODAL_STATE_PATH])

    const onChangeTag = (scope, checked, index) => {
        if (checked) selectScope.remove(index)
        else selectScope.push(scope)
        setState(MODAL_STATE_PATH + ".selectScope", selectScope);
    }

    const handleSubmit = () => {
        if (callback) callback(selectScope);
        hide();
    }

    return (
        <Modal
            title={title}
            visible={show}
            width={width}
            maskClosable={false}
            destroyOnClose
            zIndex={1001}
            onCancel={hide}
            footer={(
                <div className="flex row-end child-left--small">
                    <Button type="primary" onClick={handleSubmit}>确认</Button>
                    <Button onClick={hide}>取消</Button>
                </div>
            )}
        >
            <div className="flex space modal-scopeSelect">
                {SCOPE.map(({ label, value, childs }) => (
                    <div className="modal-scopeSelect__item" key={value}>
                        <p className="modal-scopeSelect__item-title">{label}</p>
                        <ul className="child-top-xs m-sm-t">
                            {childs.map(val => {
                                const { label, value } = val;
                                let index = -1;
                                const checked = selectScope.find((val, i) => {
                                    if (val.value === value) {
                                        index = i;
                                        return true
                                    }
                                    return false;
                                });
                                return <li key={value} className="flex hor"><CheckableTag onChange={onChangeTag.later(val, checked, index)} checked={checked}>{label}</CheckableTag></li>
                            })}
                        </ul>
                    </div>
                ))}
            </div>
        </Modal>
    );
}

export default App;